import { EllipsisDirective } from '@myre/ui-primitive-ellipsis';

import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { type LegendItem } from 'chart.js';

@Component({
  selector: 'myre-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(click)': 'isClickable ? onClick.emit() : null',
    '[class.clickable]': 'isClickable',
  },
  imports: [EllipsisDirective],
})
export class ItemComponent {
  @Input()
  public item: LegendItem;

  @Input()
  public isClickable = false;

  @Output()
  public onClick = new EventEmitter<void>();
}
